import LazyLoad from "vanilla-lazyload/dist/lazyload.js";
import { LAZY_LOAD_CONFIG } from "../config.js";
const $ = require("jquery");

$(document).ready(function() {
  new LazyLoad(LAZY_LOAD_CONFIG);
});
